import t from 'tcomb'

export default t.maybe(t.Object)
